export const UPDATE_ACTIVE_ROUTE = 'ROUTER/UPDATE_ACTIVE_ROUTE';
export const UPDATE_SCENE_STATE = 'ROUTER/UPDATE_SCENE_STATE';
export const CLEAR_SCENE_STATE = 'ROUTER/CLEAR_SCENE_STATE';
